<template>
  <div class="three-dots-menu">
    <v-menu
      v-bind="{ ...$props, ...$attrs }"
      open-on-click
      close-on-content-click
      transition="slide-y-transition"
      location="bottom right"
      :open-delay="0"
      :close-delay="50"
      content-class="three-dots-menu-wrapper"
    >
      <template #activator="{ props }">
        <button
          type="button"
          class="menu-container"
          aria-label="More actions"
          :disabled="disabled"
          v-bind="props"
        >
          <v-icon size="small" icon="$dots-vertical" />
        </button>
      </template>
      <ul class="menu-list">
        <li
          v-for="item in menuItems"
          :key="item.value"
          :class="['menu-list-item', item.value]"
          @click.stop="emit('click', item.value, document)"
        >
          <button
            type="button"
            class="menu-list-button"
          >
            <v-icon
              :icon="item.icon || '$edit-outline'"
              size="20px"
            />
            <span class="item-name">
              {{ item.text }}
            </span>
          </button>
        </li>
      </ul>
    </v-menu>
  </div>
</template>

<script setup>
defineProps({
  menuItems: {
    type: Array,
    required: true,
  },
  document: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>

<style lang="less" scoped>
.three-dots-menu {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-container {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: @grey-400;
    border-radius: 40px;
  }

  &:hover[disabled] {
    background-color: transparent;
    cursor: default;
  }

  :deep(.v-icon) path {
    fill: @icon-default;
  }
}

.three-dots-menu-wrapper {
  box-shadow: none;
  box-sizing: border-box;

  .menu-list {
    width: 100%;
    background-color: @white;
    list-style-type: none;
    border-radius: 4px;
    border: 1px solid @stroke-default;
  }

  .menu-list-button {
    display: inline-flex;
    gap: 8px;
    align-items: center;
    justify-content: start;
  }

  .menu-list-item {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 8px;
    padding: 8px 12px;
    color: @text-light;

    .item-name {
      font-size: 13px;
      font-weight: 500;
      color: @text-darkest;
    }

    &:hover {
      cursor: pointer;
      background-color: @bg-canvas;
    }

    &.delete, &.delete .item-name {
      color: @basic-red;
    }
  }
}
</style>
